// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyATmUuMfXFgLjKqv95P0GVYHgwLfuCucH8",
  authDomain: "auth.opt.glancejobs.com",
  projectId: "optglancejobscom-426b9",
  storageBucket: "optglancejobscom-426b9.appspot.com",
  messagingSenderId: "398979900931",
  appId: "1:398979900931:web:21894f638198ba11015036",
  measurementId: "G-BF906T48L8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics };